module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Barcode-scan-ba7d17afa3b9153673288307fcd52f58.svg";